import {IAnalytics} from './IAnalytics';

export class Analytics implements IAnalytics {
  analyticsPrefix:string;

  constructor(analyticsPrefix: string) {
    this.analyticsPrefix = analyticsPrefix || 'apesdk';
  }

  track(event:any): void {
    this.push(event);

  }
  setEmpID(id: string): void {
    window['dataLayer'] = window['dataLayer'] || [];

    let obj = {
      emp_id: id
    }

    try {
      let index = this.findBackwardsIndexFor('emp_id', undefined, true);

      if (index === -1) {
        window['dataLayer'] .push(obj);
      } else {
        if (window['dataLayer'] [index].emp_id !== obj.emp_id) {
          window['dataLayer'] .push(obj);
        }
      }
    } catch(e) {
      console.log(e);
    }
  }

  findBackwardsIndexFor(keyInObj: string, value: any, isDiff: boolean) {
    window['dataLayer'] = window['dataLayer'] || [];

    for (let i =   window['dataLayer'].length - 1; i>= 0; i--) {
      if (isDiff  &&   window['dataLayer'][i][keyInObj] !== value) {
        return i;
      } else if (!isDiff &&   window['dataLayer'][i][keyInObj] === value) {
        return i;
      }
    }
    return -1;
  }

  push(obj: any, ignoreEvent:boolean = false) {
    if (!ignoreEvent)
      obj.event = `${this.analyticsPrefix}_${obj.event}`;

    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push(obj);
  }
}
